import { render } from "./NumberOfInput.vue?vue&type=template&id=23574355&scoped=true&ts=true"
import script from "./NumberOfInput.vue?vue&type=script&lang=ts"
export * from "./NumberOfInput.vue?vue&type=script&lang=ts"

import "./NumberOfInput.vue?vue&type=style&index=0&id=23574355&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23574355"]])

export default __exports__